<template>
  <div :class="['new-header', headerClass]">
    <div class="logo">
      <img v-if="headerClass == 'style3'" src="@/project/assets/front/icon-logo-blue.png" alt="" />
      <img v-else src="@/project/assets/front/icon-logo-white.png" alt="" />
    </div>
    <nav>
      <ul :class="[headerClass]">
        <li v-for="(item, index) in menuItems" :key="index" :class="{ selected: selectedIndex === index }" @click="selectItem(index)">
          {{ item.name }}
        </li>
      </ul>
    </nav>
    <div v-if="!user.id" class="login-sign">
      <span :class="['login', headerClass]" @click="handleToLogin(1)">登录</span>
      <span :class="['sign', headerClass]" @click="handleToLogin(2)">注册</span>
    </div>
    <div v-else class="login-sign">
      <span :class="['login', headerClass]" @click="goBackstage">进入系统</span>
      <span :class="['sign', headerClass]" @click="EiteUser">退出</span>
    </div>

    <!-- 登录弹框 -->
    <login :visible="showLogin" :type="type" @close="showLogin = false"></login>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'newHeader',
  data() {
    return {
      menuItems: [
        { name: '首页', path: ['/'] },
        { name: '项管系统', path: ['/front/intro'] },
        { name: '工程招聘', path: ['/front/hire', '/front/hire/search'] },
        { name: '材料设备', path: ['/front/material', '/front/material/search'] },
        { name: '工程机械', path: ['/front/machine', '/front/machine/search'] },
        { name: '行业咨询', path: ['/front/business', '/front/business/search'] },
        { name: '关于我们', path: ['/front/about'] },
        { name: '下载', download: true },
      ],
      selectedIndex: null,
      user: JSON.parse(sessionStorage.getItem('userInfo')) || '',
      showLogin: false,
      type: 0,
      navsMap: {
        项目: '/project/brife',
        个人: '/personMag/index',
        施工单位: '/doer/index',
        其他公司: '/consult/index',
        材料供应商: '/supplier/index',
        机械供应商: '/supplier/index',
      },
    };
  },
  computed: {
    ...mapState({
      searchObj: (state) => state.searchObj,
      activeNav: (state) => state.activeNav,
    }),
    headerClass() {
      const path = this.$route.path;
      if (path === '/') {
        return 'style1';
      } else if (path === '/front/intro' || path === '/login') {
        return 'style2';
      } else {
        return 'style3';
      }
    },
  },
  methods: {
    selectItem(index) {
      // this.$store.commit('setActiveNav', {});
      // this.$store.commit('setSesrchContent', {});
      if (this.menuItems[index].download) {
        //下载app
        this.downloadApp();
      } else {
        this.selectedIndex = index;
        this.$router.push(this.menuItems[index].path[0]);
      }
    },
    //下载app
    downloadApp() {
      // 获取最新app下载地址
      const url = '/collective/latest';
      this.$request
        .post(url)
        .then((res) => {
          if (res.url) this.$downloadFiles(res.url);
        })
        .catch(() => {});
    },
    handleToLogin(type) {
      // this.showLogin = true;
      this.type = type;
      // this.$emit('login', type);
      this.$router.push({ path: '/login', query: { type } }).then(() => {
        this.$router.go(0);
      });
    },
    EiteUser() {
      sessionStorage.removeItem('projectInfo');
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('tokenOrder');
      sessionStorage.removeItem('userInfo');
      this.user = '';
    },
    async goBackstage() {
      if (!sessionStorage.getItem('token')) {
        this.$router.push({ path: '/' });
        return;
      }
      const navs = sessionStorage.getItem('navs');
      const url = this.navsMap[navs];
      this.$router.push({ path: url });
    },
    updateSelectedIndex() {
      const currentPath = this.$route.path;
      const index = this.menuItems.findIndex((item) => item.path.includes(currentPath));
      if (index !== -1) {
        this.selectedIndex = index;
      }
    },
  },
  mounted() {
    this.updateSelectedIndex();
  },
  watch: {
    '$route.path': 'updateSelectedIndex',
  },
};
</script>

<style lang="less" scoped>
.new-header {
  height: 68px;
  box-sizing: border-box;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  &.style1 {
    background-color: #333;
  }
  &.style2 {
    background-color: rgba(255, 255, 255, 0.15);
  }
  &.style3 {
    background-color: rgba(255, 255, 255, 1);
  }
  .logo {
    margin-right: 40px;
    img {
      width: 131px;
      height: 38px;
    }
  }
  .login-sign {
    margin-left: 180px;
    display: flex;
    height: 100%;
    .sign,
    .login {
      width: 88px;
      height: 100%;
      line-height: 68px;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      cursor: pointer;
    }
    .sign {
      font-size: 14px;
      font-weight: 400;
      &.style1 {
        background: rgba(255, 255, 255, 0.1);
        color: rgba(255, 255, 255, 1);
      }
      &.style2 {
        background-color: rgba(255, 255, 255, 0.2);
        color: rgba(255, 255, 255, 1);
      }
      &.style3 {
        background: rgba(237, 237, 237, 0.5);
        color: rgba(153, 153, 153, 1);
      }
    }
    .login {
      font-size: 14px;
      font-weight: 700;
      &.style1 {
        background: rgba(255, 255, 255, 0.2);
        color: rgba(255, 255, 255, 1);
      }
      &.style2 {
        color: rgba(27, 112, 255, 1);
        background: rgba(255, 255, 255, 1);
      }
      &.style3 {
        background: rgba(27, 112, 255, 1);
        color: rgba(255, 255, 255, 1);
      }
    }
  }
  nav ul {
    padding: 0;
    list-style: none;
    display: flex;
    gap: 40px;
    height: 64px;
    line-height: 64px;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;

    li {
      cursor: pointer;
      &.selected {
        font-weight: bold; // 选中时加粗
        position: relative;
        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -2px;
          width: 100%;
          height: 2px;
          background-color: white; // 选中时的下划线
        }
      }
    }
    &.style1 {
      color: rgba(153, 153, 153, 1);
      li {
        &.selected {
          color: rgba(255, 255, 255, 1);
          &::after {
            background-color: rgba(255, 255, 255, 1);
          }
        }
      }
    }
    &.style2 {
      color: rgba(255, 255, 255, 1);
      li {
        &.selected {
          color: rgba(255, 255, 255, 1);
          &::after {
            background-color: rgba(255, 255, 255, 1);
          }
        }
      }
    }
    &.style3 {
      color: rgba(107, 107, 107, 1);
      li {
        &.selected {
          color: rgba(27, 112, 255, 1);
          &::after {
            background-color: rgba(27, 112, 255, 1);
          }
        }
      }
    }
  }
}
</style>
